import {configureStore} from '@reduxjs/toolkit'
import rootReducer from "./reducers";

const store: any = configureStore({
    reducer: rootReducer,
});

export default store;
